import * as Yup from "yup";

// Used by AddSystemAnnouncementModal
export const Validation = Yup.object({
  type: Yup.string().required("Please select type!"),

  message: Yup.string().when(["type", "isMaintenance"], {
    is: (type, isMaintenance) => type === "Info" && isMaintenance === true,
    then: (schema) => schema.required("Please enter message!"),
    otherwise: (schema) => schema.notRequired(),
  }),

  description: Yup.string().required("Please enter description!"),

  isMaintenance: Yup.boolean().nullable(),

  actualStartAt: Yup.string().when("isMaintenance", {
    is: true,
    then: (schema) => schema.required("Please enter start time!"),
    otherwise: (schema) => schema.notRequired(),
  }),

  actualEndAt: Yup.string().when("isMaintenance", {
    is: true,
    then: (schema) => schema.required("Please enter end time!"),
    otherwise: (schema) => schema.notRequired(),
  }),

  estimatedDuration: Yup.number().when("isMaintenance", {
    is: true,
    then: (schema) => schema.required("Please enter estimated duration!").min(1),
    otherwise: (schema) => schema.notRequired(),
  }),
});

// Used by CancelSystemAnnouncementModal
export const CancelValidation = Yup.object({
  cancellationReason: Yup.string().required("Please enter cancellation reason!"),

  cancellationMessage: Yup.string().when("isCancelMessageToUser", {
    is: true,
    then: (schema) => schema.required("Please enter cancellation message!"),
    otherwise: (schema) => schema.notRequired(),
  }),
});